import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { colors, typography, spacing } from '@mehilainen/design-system-tokens';
// NOTE: Do not import these from lib root! Will cause circular deps
import { Minus, Plus } from '../../icons';
const { baseTypography } = typography;
//Custom iconwrapper to support swapping icons between states
const iconsWrapperClass = 'accordionDoubleIconWrapper';
const expandedIconClass = 'expandedAnimationIcon';
const minimizedIconClass = 'minimizedAccordionIcon';
const expandIcon = (_jsxs("div", Object.assign({ className: iconsWrapperClass }, { children: [_jsx(Minus, { className: expandedIconClass }), _jsx(Plus, { className: minimizedIconClass })] })));
export const getThemeAccordion = (tokens) => {
    return {
        MuiAccordion: {
            defaultProps: {
                disableGutters: true,
                square: true,
            },
            styleOverrides: {
                root: {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    borderBottom: '1px solid ' + colors.Gray300,
                    '&:before': {
                        display: 'none',
                    },
                },
            },
        },
        MuiAccordionSummary: {
            defaultProps: {
                expandIcon: expandIcon,
            },
            styleOverrides: {
                root: {
                    padding: 0,
                },
                expandIconWrapper: ({ ownerState }) => {
                    // MUI doesn't support swapping icons between expanded/not-expanded
                    if (ownerState.expanded) {
                        return {
                            [`& > .${iconsWrapperClass}`]: {
                                [`& > .${minimizedIconClass}`]: {
                                    display: 'none',
                                },
                                [`& > .${expandedIconClass}`]: {
                                    display: 'inline-block',
                                    height: tokens.uiElementAccordion.iconSize,
                                    width: tokens.uiElementAccordion.iconSize,
                                    color: colors.Primary500,
                                },
                            },
                        };
                    }
                    return {
                        [`& > .${iconsWrapperClass}`]: {
                            [`& > .${expandedIconClass}`]: {
                                display: 'none',
                            },
                            [`& > .${minimizedIconClass}`]: {
                                display: 'inline-block',
                                height: tokens.uiElementAccordion.iconSize,
                                width: tokens.uiElementAccordion.iconSize,
                                color: colors.Primary500,
                            },
                        },
                    };
                },
                content: {
                    fontSize: tokens.uiElementAccordion.titleFontSize,
                    fontWeight: baseTypography.weight.Regular,
                    lineHeight: baseTypography.height.Large,
                },
            },
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    padding: `0 0 ${spacing[600].px} 0`,
                    fontSize: tokens.uiElementAccordion.contentDefaultFontSize,
                },
            },
        },
    };
};
